import { render, staticRenderFns } from "./ActiveDetailDialog.vue?vue&type=template&id=57845b4b&scoped=true&"
import script from "./ActiveDetailDialog.vue?vue&type=script&lang=js&"
export * from "./ActiveDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./ActiveDetailDialog.vue?vue&type=style&index=0&id=57845b4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57845b4b",
  null
  
)

export default component.exports